import React from 'react'

export default () => (
  <svg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
    <g fill='none' fill-rule='evenodd'>
      <path d='M12 4c-4.444 0-8 3.556-8 8s3.556 8 8 8 8-3.556 8-8-3.556-8-8-8z' fill='#F1C21B' />
      <path
        d='M12.03 13.353c.277 0 .474-.066.593-.198.118-.132.183-.333.192-.602l.218-4.513c.02-.31-.064-.56-.25-.75-.187-.191-.435-.286-.745-.286s-.558.094-.744.282c-.187.187-.27.439-.25.754l.202 4.513c.015.27.082.47.2.602.119.132.314.198.585.198zm.124 3.651c.271 0 .487-.08.647-.24.16-.16.24-.379.24-.657v-.835c0-.278-.08-.497-.24-.657-.16-.16-.376-.24-.647-.24-.27 0-.486.08-.646.24-.16.16-.24.38-.24.657v.835c0 .278.08.497.24.657.16.16.375.24.646.24z'
        fill='#413F33'
        fill-rule='nonzero'
      />
    </g>
  </svg>
)
